<template>
  <b-modal
    :visible="isModalActive"
    :title="$t('Set up separate products')"
    ok-title="Accept"
    size="lg"
    @change="(val) => $emit('update:is-modal-active', val)"
  >
    <div class="m-2">
      <ProductCard :product="productData" />
      <b-table-simple responsive>
        <b-thead head-variant="primary">
          <b-tr>
            <b-td style="width: 20%;">
              {{ $t('System list') }}
            </b-td>
            <b-td>{{ $t('Setting') }}</b-td>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr>
            <b-td>{{ $t('Enable') }}</b-td>
            <b-td>
              <b-form-checkbox
                v-model="enableFlashSale"
                switch
              />
            </b-td>
          </b-tr>
          <b-tr>
            <b-td>{{ $t('Discount price') }}</b-td>
            <b-td>{{ amount }}</b-td>
          </b-tr>
          <b-tr>
            <b-td>{{ $t('Calculation Method') }}</b-td>
            <b-td>{{ calculationMethod | firstStringUpper }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <b-row>
        <b-col cols="6">
          <label>{{ $t('Discount price') }}</label>
          <cleave
            id="amount"
            v-model="amount"
            class="form-control"
            :raw="false"
            :options="optionCleave.number"
            :placeholder="$t('Amount')"
          />
        </b-col>
        <b-col cols="6">
          <label>{{ $t('Calculation Method') }}</label>
          <v-select
            id="calculationMethod"
            v-model="calculationMethod"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="name"
            :options="OptionCal"
            :clearable="false"
            :reduce="(OptionCal) => OptionCal.value"
          />
        </b-col>
      </b-row>
    </div>

    <template #modal-footer>
      <div class="w-100">

        <div class="float-right">

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            size="sm"
            class="mr-2"
            @click="typingAmount"
          >
            {{ $t('Accept') }}
            <feather-icon
              icon="ShoppingBagIcon"
              size="12"
            />
          </b-button>
        </div>

      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BTableSimple, BThead, BTh, BTbody, BTr, BTd,
  BModal,
  BRow,
  BCol,
  BTabs,
  BTab,
  BCardText,
  BFormCheckbox,
  BButton,
  BFormInput,
  BFormGroup,
  BOverlay,

} from 'bootstrap-vue'

import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import Cleave from 'vue-cleave-component'
import ProductCard from '../components/ProductCard.vue'

export default {
  components: {
    BTableSimple,
    BThead,
    BTh,
    BTbody,
    BTr,
    BTd,
    // eslint-disable-next-line vue/no-unused-components
    vSelect,
    BModal,
    // eslint-disable-next-line vue/no-unused-components
    BRow,
    // eslint-disable-next-line vue/no-unused-components
    BCol,
    BTabs,
    BTab,
    // eslint-disable-next-line vue/no-unused-components
    BCardText,
    // eslint-disable-next-line vue/no-unused-components
    BFormCheckbox,
    // eslint-disable-next-line vue/no-unused-components
    BButton,
    BFormInput,
    // eslint-disable-next-line vue/no-unused-components
    BFormGroup,
    BOverlay,
    // eslint-disable-next-line vue/no-unused-components
    ProductCard,
    Cleave,
  },
  directives: {
    Ripple,
  },
  mixins: [togglePasswordVisibility],
  model: {
    prop: 'isModalActive',
    event: 'update:is-modal-active',
  },
  props: {
    storeModuleName: {
      type: String,
      required: true,
    },
    isModalActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => { },
    },
    show: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isInitialized: false,
      dataId: null,
      currentDate: null,
      typeTime: null,
      productData: null,
      flashSale: null,
      flashSaleData: null,
      amount: '0',
      calculationMethod: 'constant',
      enableFlashSale: false,
      optionCleave: {
        number: {
          numeral: true,
        },
      },
      required,
    }
  },
  computed: {
    OptionCal() {
      return [
        { name: this.$t('Percent'), value: 'percent' },
        { name: this.$t('Constant'), value: 'constant' },
      ]
    },
  },
  watch: {
    isModalActive(val) {
      if (val) {
        this.isInitialized = false // เริ่มต้นใหม่
        this.initValues()

        if (Object.entries(this.data).length === 0) {
          // this.$refs.formData.reset()
        } else {
          const {
            id,
            currentDate,
            typeTime,
          } = this.data
          this.dataId = id
          this.currentDate = currentDate
          this.typeTime = typeTime
          this.getSettingProduct()
        }
      }
    },
  },

  methods: {
    switchChange(name, status) {
      this[name] = status
      const obj = {
        id: this.flashSale._id,
        productId: this.dataId,
        [name]: status,
      }
    },
    typingAmount() {
      const obj = {
        id: this.flashSale._id,
        productId: this.dataId,
        amount: this.amount.replaceAll(',', ''),
        calculationMethod: this.calculationMethod,
        enableFlashSale: this.enableFlashSale,
      }

      store
        .dispatch(`${this.storeModuleName}/updateSettingProduct`, obj)
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          this.getSettingProduct()
          //
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
          // eslint-disable-next-line no-unused-vars
        }).catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
    initValues() {
      this.dataId = null
      this.productData = null
      this.flashSale = null
      this.flashSaleData = null
      this.amount = '0'
      this.calculationMethod = 'constant'
      this.enableFlashSale = false
    },
    showFromCurrentLanguage(data) {
      const indexLang = data.findIndex(e => e.lang === this.$i18n.locale)
      if (indexLang > -1) {
        return data[indexLang].value
      }
      return ''
    },

    getSettingProduct() {
      store
        .dispatch(`${this.storeModuleName}/getSettingProduct`, { productId: this.dataId, currentDate: this.currentDate, typeTime: this.typeTime })
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          const { data, flashSale, flashSaleData } = result.data
          this.productData = data
          this.flashSale = flashSale
          this.flashSaleData = flashSaleData
          if (flashSaleData) {
            this.amount = flashSaleData.amount?.toString() || '0'
            this.calculationMethod = flashSaleData.calculationMethod || 'constant'
            this.enableFlashSale = flashSaleData.enableFlashSale || false
          } else {
            this.amount = flashSale.amount?.toString() || '0'
            this.calculationMethod = flashSale.calculationMethod || 'constant'
          }

          this.isInitialized = true
          // this.showToast('success', 'top-right', 'fetch Success', 'CheckIcon')
          // eslint-disable-next-line no-unused-vars
        }).catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-right',
            props: {
              title: this.$t('Error'),
              icon: 'ErrorIcon',
              variant: 'danger',
              text: this.$t(error.response.data.message),
            },
          })
          // console.log('fetchUsers Error : ', error)
          // this.showToast('danger', 'top-right', 'FetchUsers Error ', 'XCircleIcon')
        })
    },
  },
}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  #add-new-user-sidebar {
      .vs__dropdown-menu {
          max-height: 200px !important;
      }
  }
  </style>
